import { CircleF, GoogleMap, MarkerF } from '@react-google-maps/api'
import React, { Fragment } from 'react'

export const GoogleMapComponent = (props: any) => {
  const { locations } = props
  const index = 0
  const containerStyle = {
    width: "100%",
    height: "300px",
  }

  return <>
    <GoogleMap
      key={`${index}_map`}
      id={`${index}_map`}
      mapContainerStyle={containerStyle}
      center={locations[0]?.marker?.position}
      zoom={15}>
      {locations && locations.map((location: any, key: number) =>
        <Fragment key={key}>
          <MarkerF
            position={location?.marker?.position}
            label={location?.marker?.label}>

            {location?.marker?.circle &&
              <CircleF
                center={{
                  lat: location?.marker?.position.lat,
                  lng: location?.marker?.position.lng
                }}
                radius={location?.marker?.circle.radius.meters}
                options={location?.marker?.circle.options}
              />
            }
          </MarkerF>
        </Fragment>
      )}
    </GoogleMap>
  </>
}